<template>
    <div>
        <div class="row propertylist" v-for="property in properties">
            <div class="col-md-5 pl-0 propertyimage"><img :src="propertyImage(property)">
                <div class="leasetag">{{ property.type }}</div>
            </div>
            <div class="col-md">
                <div class="row p-4">
                    <div class="col-md">
                        <pre>{{ property.usage }}</pre>
                        <h3 v-if="property.shopping_center_name">{{ property.shopping_center_name }}</h3>
                        <h3>{{ property.city }}, {{ property.state }}</h3>
                        <p>{{ property.street }}</p>

                    </div>
                    <div class="col-md propertybtn">
                        <div><a :href= "'/property/' + property.slug" >
                            <button>More Info</button>
                        </a></div>
                        <div><a :href= "'/property/' + property.slug + '#inquire'" >                            
                            <button>Inquire</button>
                        </a></div>
                    </div>
                </div>

                <div class="row p-2 m-4 align-items-end border-top">

                    <div class="col">GLA: {{ property.square_feet}}</div>
                    <div class="col">Price per SQF: {{ property.negotiable ? 'Negotiable' : '$' + property.price_per_sqft}}</div>
                    <div class="col" v-if="property.nnn_rate">NNN Rate: ${{ property.nnn_rate }}</div>
                </div>
            </div>
        </div>


       
    </div>
</template>

<script>
    module.exports = {
        props:['properties'],
        methods: {
            propertyImage: function(property) {
                if (property.images.length === 0){
                    return 'https://placehold.it/828x408';
                }
                return property.images[0].path;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// themes/ldc/assets/js/properties/PropertyList.vue